import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { RootState } from 'app/providers/StoreProvider'
import { userApi } from "shared/api/userApi"


export const getUserAgreementThunk = createAsyncThunk(
  "userAgreement/getUserAgreementThunk",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState
    try {
      const response = await userApi.getOffers({ type: state.userAgreement.type, tenant_name: state.userAgreement.tenantName })
      if (!response?._embedded?.offers?.length) {
        dispatch(userAgreementActions.setTextContent("Something is going wrong, try again later"))
        return
      }
      const linkContent = response?._embedded?.offers[0]?._links?.content?.href
      if (!linkContent) {
        dispatch(userAgreementActions.setTextContent("Error: No content link found"))
        return
      }
      const rsp = await userApi.getContentOffer(linkContent)
      if (!rsp) {
        dispatch(userAgreementActions.setTextContent("Error: No content available"))
        return
      }
      dispatch(userAgreementActions.setTextContent(rsp))
    } catch (error) {
      console.error("Error fetching user agreement:", error)
    }
  }
)

export const getOfferThunk = createAsyncThunk(
  "userAgreement/getOfferThunk",
  async (offerId: string, { dispatch }) => {
    try {
      const response = await userApi.getOffer(offerId)
      const linkContent = response._links?.content?.href
      if (!linkContent) {
        dispatch(userAgreementActions.setTextContent("Error: No content link found"))
        return
      }
      const rsp = await userApi.getContentOffer(linkContent)
      if (!rsp) {
        dispatch(userAgreementActions.setTextContent("Error: No content available"))
        return
      }
      dispatch(userAgreementActions.setTextContent(rsp))
    } catch (error) {
      dispatch(userAgreementActions.setTextContent(error.description))
    }
  }
)

export const userAgreementSlice = createSlice({
  name: 'userAgreement',
  initialState: {
    title: '',
    type: '',
    tenantName: 'default',
    textContent: '',
    isUserAgreementModalOpen: false,
  },
  reducers: {
    setTextContent: (state, action) => {
      state.textContent = action.payload
    },
    setIsUserAgreementModalOpen: (state, action) => {
      state.isUserAgreementModalOpen = true
      state.type = action.payload.type ? action.payload.type : state.type
      state.tenantName = action.payload.tenantName ? action.payload.tenantName : state.tenantName
      state.title = action.payload.title ? action.payload.title : state.title
    },
    setIsUserAgreementModalClose: (state) => {
      state.isUserAgreementModalOpen = false
    },
    resetState: (state) => {
      state.title = ''
      state.type = ''
      state.tenantName = 'default'
      state.textContent = ''
    },
  },
})

export const { setIsUserAgreementModalOpen, setIsUserAgreementModalClose } = userAgreementSlice.actions
export const userAgreementReducer = userAgreementSlice.reducer
export const userAgreementActions = userAgreementSlice.actions

